/* Complément cochable (Vanille Désiré)

   Pile live : le formulaire produit est <form data-vd-pdp-form> dans
   sections/vd-yc-product.liquid, et c'est assets/vd-yc.js qui intercepte son
   submit (écouteur document en phase bulle) pour poster /cart/add puis ouvrir
   le tiroir. Il n'y a ni product-form.js, ni cart-drawer / cart-notification
   (custom elements Dawn), ni fetchConfig / publish / PUB_SUB_EVENTS.

   Trois responsabilités :

   1. Mode automatique. Quand le marchand n'a choisi aucun produit dans le bloc
      (data-auto="true"), on interroge les recommandations complémentaires
      Shopify (routes.product_recommendations_url + '.json?intent=complementary',
      alimentées par l'app gratuite Search & Discovery) et on installe le premier
      produit exploitable dans la carte déjà rendue par Liquid. Le contenu servi
      par le serveur (produit par défaut du réglage de section) sert de repli :
      il reste affiché si aucune recommandation ne remonte. Rien n'est à régler
      fiche par fiche.

   2. Ajout groupé, PLUSIEURS instances (03/09/2026). Une page peut porter
      plusieurs <vd-addon-checkbox> pour le même formulaire : le complément
      recommandé (poivre) et l'option de conditionnement (tube en verre,
      snippets/vd-conditionnement.liquid). Un seul écouteur document, en phase
      capture, prend la main AVANT vd-yc.js (stopImmediatePropagation) dès
      qu'au moins une instance est cochée, et envoie TOUS les articles dans un
      seul POST /cart/add au format items[] : produit principal en premier,
      puis chaque complément coché. Une instance data-quantity-follow="main"
      prend la quantité du champ quantité principal (un tube par sachet), les
      autres partent à 1. Aucune instance cochée : parcours normal du thème,
      zéro interférence.

   3. Option de conditionnement (data-vd-cond). L'instance ne s'affiche que
      pour une variante qui se compte en gousses, de 1 à data-max, et dont le
      calibre (axe data-cal-axe, première clé de la valeur) n'est pas dans
      data-exclure : un tube de 18 cm ne loge pas de XL. On écoute l'événement
      document 'vd:variant-change' (émis par assets/vd-pdp-format.js) et, en
      repli, 'change' sur le <select data-vd-variant-select> du formulaire.
      Repliée, l'instance se décoche (retour sur « sachet »).

   Priorité laissée à assets/vd-intl.js : lui aussi écoute le submit en phase
   capture, pour bloquer l'ajout sous le minimum d'achat export. Comme notre
   écouteur est enregistré avant le sien (ordre des scripts defer), on
   revérifie ici le minimum et on laisse filer l'événement quand il n'est pas
   atteint : le garde-fou export reste prioritaire. */

(function () {
  'use strict';

  if (customElements.get('vd-addon-checkbox')) return;

  /* ---------- Registre des instances et interception unique ---------- */

  var instances = [];
  var listening = false;
  var loading = false;

  /* ---------- Compte de gousses, miroir de snippets/vd-compte-gousses ----------

     Même règle que le Liquid, et pour la même raison : Shopify TRADUIT les
     valeurs d'option. « 10 gousses » devient « 10 Vanilleschoten » en
     allemand, « 10 baccelli di vaniglia » en italien, « 10 vanillestokjes »
     en néerlandais. L'ancienne détection cherchait un mot d'une liste
     française et rendait 0 dans ces trois langues : l'option de
     conditionnement ne s'y affichait donc jamais.

     Ce qui ne se traduit pas : la forme « nombre + mot », les séparateurs
     « / » et « · », et les unités de mesure. On garde le dernier segment,
     on écarte les longueurs (cm, mm : c'est un calibre) puis les masses
     et volumes (g, kg, ml... : c'est un conditionnement au poids), et on
     lit le premier nombre de ce qui reste. */

  var UNITES_POIDS = ['g', 'kg', 'mg', 'ml', 'cl', 'l', 'oz', 'lb'];

  function compteGousses(valeur) {
    var s = String(valeur || '').toLowerCase();
    s = s.split('/').pop();
    s = s.split('·').pop().trim();
    if (s.indexOf('cm') !== -1 || s.indexOf('mm') !== -1) return 0;
    var mots = s.split(/\s+/).filter(Boolean);
    for (var i = 0; i < mots.length; i++) {
      var n = parseInt(mots[i], 10);
      if (!isNaN(n) && n > 0) {
        var suivant = (mots[i + 1] || '').trim();
        return UNITES_POIDS.indexOf(suivant) === -1 ? n : 0;
      }
    }
    return 0;
  }

  function listen() {
    if (listening) return;
    listening = true;
    document.addEventListener('submit', onSubmit, true);
  }

  function belowMinimum(form) {
    var input = form.querySelector('input[name="quantity"][data-vd-min-qty]');
    if (!input) return false;
    var min = parseInt(input.dataset.vdMinQty, 10);
    if (isNaN(min) || min <= 1) return false;
    var value = parseInt(input.value, 10);
    return isNaN(value) || value < min;
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function syncExpress(form) {
    if (!form) return;
    var groupe = instances.some(function (instance) { return instance.participates(form); });
    var boutons = form.querySelectorAll('.vd-pdp__express');
    for (var i = 0; i < boutons.length; i++) {
      boutons[i].hidden = groupe;
      boutons[i].style.display = groupe ? 'none' : '';
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var actives = instances.filter(function (instance) {
      return instance.participates(form);
    });
    if (!actives.length) return;
    // Minimum d'achat export non atteint : on laisse vd-intl.js bloquer.
    if (belowMinimum(form)) return;

    // Empêche l'écouteur de vd-yc.js (phase bulle) de traiter l'ajout.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (loading) return;
    addAllToCart(form, actives);
  }

  async function addAllToCart(form, actives) {
    // Le sélecteur de variante est un <select name="id">, pas un <input>.
    var idField = form.querySelector('[name="id"]');
    var quantityField = form.querySelector('input[name="quantity"]');
    var mainVariantId = Number(idField && idField.value);
    var mainQuantity = (quantityField && parseInt(quantityField.value, 10)) || 1;
    if (mainQuantity < 1) mainQuantity = 1;

    var items = [{ id: mainVariantId, quantity: mainQuantity }];
    actives.forEach(function (instance) {
      var addonVariantId = Number(instance.dataset.variantId);
      if (!addonVariantId) return;
      var follow = instance.dataset.quantityFollow === 'main';
      items.push({ id: addonVariantId, quantity: follow ? mainQuantity : 1 });
    });

    if (!mainVariantId || items.length < 2) {
      // Rien d'exploitable : on laisse repartir le parcours normal.
      passthrough(form, actives);
      return;
    }

    var submitButton = form.querySelector('[type="submit"]');
    var labelEl = submitButton && submitButton.querySelector('.vd-pdp__add-label');
    var originalLabel = labelEl ? labelEl.textContent : null;
    loading = true;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }
    if (labelEl) labelEl.textContent = '…';

    try {
      var response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      var parsed = await response.json().catch(function () { return null; });

      if (!response.ok || (parsed && parsed.status)) {
        // Stock insuffisant sur un complément, variante retirée…
        // L'ajout items[] est atomique : rien n'est entré au panier, on
        // retombe sur l'ajout du seul produit principal.
        console.error('[vd-addon-checkbox]', (parsed && (parsed.description || parsed.message)) || response.status);
        restore(submitButton, labelEl, originalLabel);
        passthrough(form, actives);
        return;
      }

      // Les compléments sont au panier : on repart de cases décochées pour
      // qu'un second ajout reste un geste conscient.
      actives.forEach(function (instance) { instance.setChecked(false); });

      if (window.vdCart) {
        await window.vdCart.refresh();
        window.vdCart.open();
      } else {
        window.location = cartUrl();
        return;
      }
    } catch (error) {
      console.error('[vd-addon-checkbox]', error);
      window.location = cartUrl();
      return;
    } finally {
      loading = false;
    }

    restore(submitButton, labelEl, originalLabel);
  }

  function restore(submitButton, labelEl, originalLabel) {
    loading = false;
    if (labelEl && originalLabel !== null) labelEl.textContent = originalLabel;
    if (!submitButton) return;
    submitButton.disabled = false;
    submitButton.removeAttribute('aria-busy');
  }

  /* Rejoue le submit en laissant passer notre propre interception, pour
     que le thème traite l'ajout du produit principal comme d'habitude.
     Les cases restent décochées : les compléments ne sont pas entrés au
     panier, et l'état affiché doit dire la vérité. Différé d'un tick pour
     ne pas relancer une soumission depuis l'intérieur de la distribution de
     l'événement submit d'origine. */
  function passthrough(form, actives) {
    actives.forEach(function (instance) { instance.setChecked(false); });
    setTimeout(function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }, 0);
  }

  /* ---------- L'élément ---------- */

  customElements.define(
    'vd-addon-checkbox',
    class VdAddonCheckbox extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-vd-addon-input]');
        this.card = this.querySelector('[data-vd-addon-card]');
        this.thumb = this.querySelector('[data-vd-addon-thumb]');
        this.titleEl = this.querySelector('[data-vd-addon-title]');
        this.priceEl = this.querySelector('[data-vd-addon-price]');

        this.onToggle = this.onToggle.bind(this);
        this.addEventListener('change', this.onToggle);
        this.onToggle();

        if (instances.indexOf(this) === -1) instances.push(this);
        this.onToggle();
        listen();

        if (this.dataset.auto === 'true') this.resolveRecommendation();
        if (this.hasAttribute('data-vd-cond')) this.initConditionnement();
      }

      disconnectedCallback() {
        var i = instances.indexOf(this);
        if (i !== -1) instances.splice(i, 1);
        syncExpress(document.getElementById(this.dataset.productFormId));
        if (this.onVariantEvent) document.removeEventListener('vd:variant-change', this.onVariantEvent);
        if (this.select && this.onSelectChange) this.select.removeEventListener('change', this.onSelectChange);
      }

      /* Cette instance doit-elle partir avec ce formulaire ? */
      participates(form) {
        if (!this.isConnected) return false;
        // form.id renverrait le champ <select name="id"> du formulaire, pas
        // l'attribut : on lit l'attribut. (Défaut hérité, corrigé le 03/09/2026.)
        if (form.getAttribute('id') !== this.dataset.productFormId) return false;
        if (this.hidden) return false;
        if (!this.input || !this.input.checked) return false;
        return !!this.dataset.variantId;
      }

      /* ---------- Mode automatique ---------- */

      async resolveRecommendation() {
        const base = this.dataset.recommendationsUrl;
        const productId = this.dataset.productId;
        if (!base || !productId) return;

        const url = `${base}.json?product_id=${encodeURIComponent(productId)}&limit=${
          this.dataset.limit || 6
        }&intent=complementary`;

        try {
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const data = await response.json();
          const products = (data && data.products) || [];

          for (const candidate of products) {
            if (String(candidate.id) === String(productId)) continue;
            // Le vrac B2B est volontairement hors de ces mécaniques B2C.
            // Détection par ÉTIQUETTE : la charge utile de /recommendations
            // porte `tags`, qui n'est pas traduit, là où `handle` l'est
            // (« -vrac » devient « -lose » en allemand, « -sfuso » en
            // italien, « -bulk » en anglais et en néerlandais).
            if ((candidate.tags || []).indexOf('vrac') !== -1) continue;
            // Un article de conditionnement n'est pas un complément à recommander.
            if (String(candidate.type || '').toLowerCase() === 'conditionnement') continue;
            const variant = (candidate.variants || []).find((v) => v.available);
            if (!variant) continue;
            this.applyProduct(candidate, variant);
            return;
          }
        } catch (error) {
          // Pas de recommandation exploitable : on garde le repli servi par Liquid.
          console.error('[vd-addon-checkbox]', error);
        }
      }

      applyProduct(candidate, variant) {
        this.dataset.variantId = variant.id;

        if (this.titleEl) this.titleEl.textContent = candidate.title || '';
        if (this.priceEl) this.priceEl.textContent = '+ ' + this.formatMoney(variant.price);

        if (this.thumb) {
          this.thumb.textContent = '';
          if (candidate.featured_image) {
            const image = document.createElement('img');
            const separator = candidate.featured_image.indexOf('?') === -1 ? '?' : '&';
            image.src = `${candidate.featured_image}${separator}width=160`;
            image.alt = '';
            image.width = 48;
            image.height = 48;
            image.loading = 'lazy';
            this.thumb.appendChild(image);
          }
        }

        this.hidden = false;
      }

      /* Aligné sur formatMoney() de assets/vd-yc.js : le filtre money de Liquid
         suit le format monétaire de la boutique, pas la locale du visiteur. */
      formatMoney(cents) {
        const currency =
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        if (currency === 'EUR') {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency',
            currency: currency,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2) + ' ' + currency;
        }
      }

      /* ---------- État visuel ---------- */

      onToggle() {
        if (this.card && this.input) {
          this.card.classList.toggle('is-checked', this.input.checked);
        }
        // Cartes radio de l'option de conditionnement : l'état actif suit
        // l'input de chaque carte.
        var opts = this.querySelectorAll('[data-vd-cond-opt]');
        for (var i = 0; i < opts.length; i++) {
          var radio = opts[i].querySelector('input');
          opts[i].classList.toggle('is-active', !!(radio && radio.checked));
        }
        // Les complements passent par le panier complet avant le paiement.
        syncExpress(document.getElementById(this.dataset.productFormId));
      }

      /* Coche ou décoche le complément. Quand l'input est un bouton radio
         (cartes du conditionnement), décocher = revenir sur la carte par
         défaut (data-vd-addon-default), pour qu'un choix reste toujours fait. */
      setChecked(checked) {
        if (!this.input) return;
        if (checked) {
          this.input.checked = true;
        } else if (this.input.type === 'radio') {
          var fallback = this.querySelector('[data-vd-addon-default]');
          if (fallback) fallback.checked = true;
          else this.input.checked = false;
        } else {
          this.input.checked = false;
        }
        this.onToggle();
      }

      /* ---------- Option de conditionnement ---------- */

      initConditionnement() {
        this.calAxe = parseInt(this.dataset.calAxe, 10);
        if (isNaN(this.calAxe)) this.calAxe = -1;
        this.maxGousses = parseInt(this.dataset.max, 10) || 10;
        this.exclus = String(this.dataset.exclure || 'xl')
          .toLowerCase()
          .split(',')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
        /* data-mots n'est plus lu : le compte est structurel, donc valable
           dans les six langues. L'attribut reste posé par le Liquid, il est
           simplement sans effet. */

        var form = document.getElementById(this.dataset.productFormId);
        this.select = form && form.querySelector('[data-vd-variant-select]');

        this.onVariantEvent = (event) => {
          var d = event && event.detail;
          this.evaluate(d && Array.isArray(d.options) ? d.options : null);
        };
        this.onSelectChange = () => this.evaluate(null);
        document.addEventListener('vd:variant-change', this.onVariantEvent);
        if (this.select) this.select.addEventListener('change', this.onSelectChange);

        this.evaluate(null);
      }

      /* Les valeurs d'option de la variante choisie, lues sur le select caché
         (data-options séparé par « || »). */
      currentOptions() {
        var opt = this.select && this.select.selectedOptions && this.select.selectedOptions[0];
        var raw = opt && opt.dataset.options;
        if (!raw) return null;
        return raw.split('||');
      }

      /* Le tube ne vaut que pour un format en gousses (1 à max) d'un calibre
         qui loge dans le tube. Sinon : replié et décoché. */
      evaluate(options) {
        var opts = options || this.currentOptions();
        if (!opts) return;
        var ok = false;
        var cle = '';
        if (this.calAxe >= 0 && opts[this.calAxe] != null) {
          cle = String(opts[this.calAxe]).trim().split(/\s+/)[0].toLowerCase();
        }
        if (cle && this.exclus.indexOf(cle) === -1) {
          for (var i = 0; i < opts.length; i++) {
            if (i === this.calAxe) continue;
            var n = compteGousses(opts[i]);
            if (n >= 1 && n <= this.maxGousses) { ok = true; break; }
          }
        }
        this.hidden = !ok;
        if (!ok) this.setChecked(false);
      }
    }
  );
})();
